import React from "react";
import theme from "../../../styles/theme";
import RiskMatrix from "../Canevas/RiskMatrix";
import KpiGroup from "../../reusable/Forms/KpiGroup";

const containerStyle = {
  width: "100%",
  maxWidth: 900,
  margin: "0 auto",
  padding: "24px 32px",
  background: theme.colors.background.paper,
  borderRadius: theme.borders.radius.md,
  boxShadow: theme.shadows.md,
};

const sectionStyle = {
  marginBottom: 32,
  borderBottom: `1px solid ${theme.colors.borders.light}`,
  paddingBottom: 24,
};

const titleStyle = {
  fontSize: 20,
  fontWeight: 600,
  marginBottom: 12,
  color: theme.colors.text.title,
};

const labelStyle = {
  fontWeight: 500,
  color: theme.colors.text.muted,
  marginBottom: 4,
};

const valueStyle = {
  fontSize: 16,
  color: theme.colors.text.body,
};


const RiskReportPreview = ({ risk }) => {
  return (
    <div style={containerStyle}>

      {/* ===========================================================
          HEADER
      ============================================================ */}
      <div style={sectionStyle}>
        <div style={titleStyle}>Rapport Risque</div>

        <div style={labelStyle}>Titre</div>
        <div style={valueStyle}>{risk.title}</div>

        <div style={{ height: 12 }} />

        <div style={labelStyle}>Catégorie</div>
        <div style={valueStyle}>{risk.categorie?.label}</div>

        <div style={{ height: 12 }} />

        <div style={labelStyle}>Statut</div>
        <div style={valueStyle}>{risk.statut?.label}</div>
      </div>

      {/* ===========================================================
          DESCRIPTION
      ============================================================ */}
      <div style={sectionStyle}>
        <div style={titleStyle}>Description</div>
        <div style={valueStyle}>{risk.description || "—"}</div>
      </div>

      {/* ===========================================================
          KPI / Métriques
      ============================================================ */}
      <div style={sectionStyle}>
        <div style={titleStyle}>Indicateurs</div>

        <KpiGroup
          items={risk.kpi || []}
          gap={16}
          size="medium"
        />
      </div>

      {/* ===========================================================
          MATRICE DE RISQUES
      ============================================================ */}
      <div style={sectionStyle}>
        <div style={titleStyle}>Matrice de Risques</div>

        <RiskMatrix
          rows={5}
          cols={5}
          axisX={risk.axisX}
          axisY={risk.axisY}
          selected={risk.position}
        />
      </div>

      {/* ===========================================================
          COMMENTAIRES
      ============================================================ */}
      <div style={sectionStyle}>
        <div style={titleStyle}>Commentaires</div>
        <div style={valueStyle}>{risk.commentaires || "—"}</div>
      </div>

    </div>
  );
};

export default RiskReportPreview;
